import { DeliveryClient, TypeResolver } from '@kentico/kontent-delivery';
import { environment } from 'src/environments/environment';
import { Article } from './models/article';
import { Button } from './models/button';
import { Category } from './models/category';
import { CategoryLink } from './models/category_link';
import { ContentSectionBrightcoveVideo } from './models/content_section___brightcove_video';
import { ContentSectionCategoryLinks } from './models/content_section___category_links';
import { ContentSectionFullWidthImage } from './models/content_section___full_width_image';
import { ContentSectionPersonProfiles } from './models/content_section___person_profiles';
import { ContentSectionText } from './models/content_section___text';
import { Course } from './models/course';
import { Lesson } from './models/lesson';
import { Page } from './models/page';
import { PageAbout } from './models/page___about';
import { SourceContentExternalUrl } from './models/source_content___external_url';
import { SourceContentPdf } from './models/source_content___pdf';
import { SourceContentPodcast } from './models/source_content___podcast';
import { SourceContentVideo } from './models/source_content___video';
import { Tag } from './models/tag';
import * as i0 from "@angular/core";
var KontentService = /** @class */ (function () {
    function KontentService() {
        this.deliveryClient = new DeliveryClient({
            projectId: environment.kontent.deliveryProjectId,
            previewApiKey: environment.kontent.previewApiKey,
            globalQueryConfig: {
                usePreviewMode: environment.kontent.usePreviewMode
            },
            typeResolvers: [
                new TypeResolver('article', function () { return new Article(); }),
                new TypeResolver('button', function () { return new Button(); }),
                new TypeResolver('category', function () { return new Category(); }),
                new TypeResolver('category_link', function () { return new CategoryLink(); }),
                new TypeResolver('content_section__brightcove_video', function () { return new ContentSectionBrightcoveVideo(); }),
                new TypeResolver('content_section__category_links', function () { return new ContentSectionCategoryLinks(); }),
                new TypeResolver('content_section__full_width_image', function () { return new ContentSectionFullWidthImage(); }),
                new TypeResolver('content_section__person_profiles', function () { return new ContentSectionPersonProfiles(); }),
                new TypeResolver('content_section__text', function () { return new ContentSectionText(); }),
                new TypeResolver('course', function () { return new Course(); }),
                new TypeResolver('lesson', function () { return new Lesson(); }),
                new TypeResolver('page', function () { return new Page(); }),
                new TypeResolver('page___about', function () { return new PageAbout(); }),
                new TypeResolver('source_content___external_url', function () { return new SourceContentExternalUrl(); }),
                new TypeResolver('source_content___pdf', function () { return new SourceContentPdf(); }),
                new TypeResolver('source_content___podcast', function () { return new SourceContentPodcast(); }),
                new TypeResolver('source_content___video', function () { return new SourceContentVideo(); }),
                new TypeResolver('tag', function () { return new Tag(); }),
            ]
        });
    }
    KontentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function KontentService_Factory() { return new KontentService(); }, token: KontentService, providedIn: "root" });
    return KontentService;
}());
export { KontentService };
